import { render, staticRenderFns } from "./EvaluationDetail.vue?vue&type=template&id=89ab4354&scoped=true&"
import script from "./EvaluationDetail.vue?vue&type=script&lang=js&"
export * from "./EvaluationDetail.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationDetail.vue?vue&type=style&index=0&id=89ab4354&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ab4354",
  null
  
)

export default component.exports